export default "__VITE_ASSET__2c91a34b__"